import * as React from "react"
import { useSelector, useDispatch } from "react-redux"
import { actionCreators as modelActionCreators } from "../../store/Model"
import { actionCreators as optimActionCreators } from "../../store/Optim"
import { actionCreators as GlobalStoreCreator } from "../../store/General"
import { computeFordModel } from '../../utils/forecastHelper'
import { actionCreators as fordForecastActionCreators } from '../../store/FordForecast'
import { FORD_FORECAST } from '../../store/action-types'
import { ToggleSwitch } from "../common/ToggleSwitch"
import { ContinBox } from "./att-editor/ContinBox"
import "./AttributeBox.scss"
import * as metaUtils from '../../utils/metaUtils'
import { availablePlugins } from "@babel/standalone"

export function AttributeBoxFordP833({ prod, att, configModel, allowOptimize, monitor_atts }) {

  //const cfgModel = useSelector(state => state.dcm.configs[configModel])//send in specific year
  const models = useSelector(state => state.model)//send in specific year
  const auth = useSelector(state => state.auth)
  const study = useSelector(state => state.study)
  const filter = useSelector(state => state.filter)
  const fordForecasterStore = useSelector(state => state.forecaster.fordForecast)
  let model = models[configModel]
  let prodDef_atts = model?.config?.productDef?.atts

  // const optState = useSelector(state => state.optimizer)  
  // const currentProd = optState?.prodsToOpt.find(p => p.uid === prod.uid)
  // const prodsToOptAtts = currentProd?.attNames
  const dispatch = useDispatch()

  if (!model || !prod || !att) return null
  
  //const { play, base } = cfgModel 
  const play = model.config?.play
  const base = model.config?.base

  //JUST FOR THIS FORD P833 PROJECT!!!
  const basePriceAtt = 'base_price_01'
  const datasetFilter = filter.selected['fordp833_filters'] || {}
  

  let dirty = false
  let error = null

  const isAttLocked = false //!prodsToOptAtts?.includes(att.name)   
  const debug = false
  let content = null


  const setPlay = async (prodId, attname, level_val) => {

    //set the models value 
    const att_name = attname.split('_')[0]
    const util_level = parseInt(attname.split('_')[2], 10)
    const utility_name = `${attname.split('_')[0]}${util_level}`
    const isModel2 = ['utility', 'bed', 'storage', 'conven', 'audio', 'driverassist', 'materialprot', 'chargingacc'].includes(att_name)
    const modelname = isModel2 ? `dcm_fordp833_${utility_name}` : `dcm_fordp833_${att_name}`
    const model = models[modelname]
    
    const prodDef_atts = model?.config?.productDef?.atts
    const num_prods = model?.modelInfo?.numProdsOnFly
    const att_label = prodDef_atts.find(a => a.name === att_name)?.label

    const originalPlay = { ...models['dcm_fordp833_base']?.config.play[0] }
    const play_config = []

    // console.log('att_name: ', att_name);
    // console.log('util_level: ', util_level);
    // console.log('prodDef_atts: ', prodDef_atts);

    // Dynamically create products
    for (let i = 1; i <= num_prods; i++) {
      const levelLabel = isModel2
        ? prodDef_atts.find(a => a.name === att_name)?.levels.find(l => l.value == util_level)?.label
        : prodDef_atts.find(a => a.name === att_name)?.levels[i - 1]?.label // Use index for non-Model2

        const productConfig = {
            uid: `prod${i}`,
            label: levelLabel || null, //`${prodDef_atts.find(a => a.name === att_name)?.levels.find(l => l.value == util_level)?.label || null}`,
            available: 1,
            base_price_01: attname === 'base_price_01' ? level_val : originalPlay.base_price_01,
            [`${att_name}`]: isModel2 ? util_level : i,
        }

        const priceAttName = isModel2 ? `${att_name}_price_0${util_level}` : `${att_name}_price_0${i}`
        const priceAtt = prodDef_atts.find((a) => a.name === priceAttName)
        if (priceAtt && priceAtt.levels?.length > 1) {
            productConfig[priceAttName] = attname.includes(isModel2 ? util_level.toString() : i.toString())
                ? level_val
                : originalPlay[priceAttName]
        }
        play_config.push(productConfig)
    }

    // console.log('play_config', play_config);
    // console.log('attname', attname);
    // console.log('level_val', level_val);

    //always set play config for dcm_fordp833_base prod1
    await dispatch(modelActionCreators.setPlay(`dcm_fordp833_base`, prodId, attname, level_val))


   
  }


  const setLevelAllow = (prodId, attname, level_val, allowed) => {
    dispatch(optimActionCreators.setLevelAllow(prodId, attname, level_val, allowed))
    dispatch(GlobalStoreCreator.setGlobalStore('forecast_needed', true))
  }
    
  if (att.type === "discrete") {

    const levelsOpt = att.levels || []
    // console.log('levelsOpt', levelsOpt);
    // console.log('playAttbox', play);
    // console.log('baseAttbox', base);
    let playValue = play.find(p => p.uid === prod.uid)[att.name] || att.defaultValue
    const baseValue = base.find(p => p.uid === prod.uid)?.[att.name] || att.defaultValue

    // console.log('playvalue', playValue);
    // console.log('baseValue', baseValue);
    // dirty = playValue != baseValue

    const sel_level = att.levels.find((level) => playValue == level.value) || att.levels[0]
    const base_level = att.levels.find((level) => baseValue == level.value) || att.levels[0]

    content = att.levels.map((level, idx) => {

      const isLevelAllowed = levelsOpt.find((l) => l.value === level.value)?.allowed
      const priceAttName = `${att.name}_price_0${level.value}`
      // console.log('priceAttName', priceAttName);
      const priceAtt = prodDef_atts.find((prodAtt) => prodAtt.name === priceAttName)
      // console.log('priceAtt', priceAtt);
      // console.log('att.name', att.name);
      
      const priceLevels = priceAtt?.levels || []
      const playPrice = play.find(p => p.uid === prod.uid)[priceAtt.name] || priceAtt.defaultValue

      const sel_price = priceLevels.find((priceLevel) => playPrice == priceLevel.value) || priceAtt.levels[0]

      let base_price_att = base.find(p => p.uid === prod.uid)[priceAtt.name] || priceAtt.defaultValue
      dirty = playPrice != base_price_att
   
 

      return !allowOptimize || isAttLocked ? (
        <div key={`${att.name}:${level.value}`} className="att-level-row">
          <div
            className={`att-level-price ${level === sel_level ? "sel" : ""}`}
            title={level.label}
          >
            {debug ? <span>[{level.value}]</span> : null} {level.label}
          </div>

          <div className="price-boxes">
            {priceLevels.map((priceLevel, index) => (
              <div
                key={index}
                className={`price-box ${sel_price?.label === priceLevel?.label ? "sel" : ""}`}
                onClick={() => setPlay(prod.uid, priceAtt.name, priceLevel.value)}
              >
                {priceLevel?.label}
              </div>
            ))}
          </div>
        </div>
      ) : (
        // Show the constraints way
        <div
          key={`${att.name}:${level.value}`}
          className={`opt-att-level with-toggle${isLevelAllowed ? "" : " off"}`}
          onClick={() => setLevelAllow(prod.uid, att.name, level.value, !isLevelAllowed)}
        >
          <ToggleSwitch className="mini" on={isLevelAllowed}>
            {level.label}
          </ToggleSwitch>
        </div>
      )
    })
  }
  else if (att.type === "multiselect") {
    
      const levelsOpt = att.levels || []

      let nbSelected = 0
      const yesValue = att.yesValue || 1
      const noValue = att.noValue || 0

      content = att.options.map((option) => {
        const isOptionAllowed = !levelsOpt.includes(option.name)

        let playValue = play[option.name] == null ? att.defaultValue : play[option.name]
        const baseValue = base[option.name] == null ? att.defaultValue : base[option.name]
        if (playValue != baseValue) {
          dirty = true
        }

        const selected = playValue == yesValue

        if (selected) {
          nbSelected++
        }

        const isLevelAllowed = true // todo

        const itemDirty = playValue != baseValue

        return !allowOptimize || isAttLocked ? ( 
          // show the regular way
          <div className='level-container'>
            <div key={`${att.name}:${option.name}`} className={"att-level" + (selected ? " sel" : "")} onClick={() => setPlay(prod.uid, option.name, selected ? noValue : yesValue)}>
              {debug ? <span>[{option.name}]</span> : null} {option.label}
              {itemDirty ? (
                <span className="item-dirty">
                  <i className="fas fa-circle" />
                </span>
              ) : null}
              {/* {level === base_level ? <span className='base-level'>base</span> : null} */}
              </div>
            </div>
        ) : (
            // show the constraints way
          <div key={`${att.name}:${option.name}`} className={"att-level with-toggle" + (isLevelAllowed ? "" : " off")} onClick={() => setLevelAllow(prod.uid, option.name, level.value, !isLevelAllowed)}>
            <ToggleSwitch 
                className='mini' 
                on={isLevelAllowed}                
              >Allow: {option.label}
            </ToggleSwitch>
            </div>
          
        )
      })

      if (att.maxSelect !== null && nbSelected > att.maxSelect) {
        error = `Too many options are selected. Select no more than ${att.maxSelect}.`
      }
    }
    else if (att.type === "contin") {

      let playValue = play[att.name] != null ? play[att.name] : att.defaultValue
      const baseValue = base[att.name] != null ? base[att.name] : att.defaultValue
      dirty = playValue != baseValue

      content = (
        <div key={att.name} className="contin-area">
          {!allowOptimize || isAttLocked ? ( 
            // show the regular way
            <div>
              <ContinBox
                key={prod.uid + ":" + att.name}
                att={att}
                slot={prod}
                playValue={playValue}
                baseValue={baseValue}
                onChange={(newValue) => {setPlay(prod.uid, att.name, newValue) }}
              />
            </div>
          ) : (
            // show the constraints way
            <div className="contin-range">
              Min: <input type="text" className="rangebox" defaultValue={att.min} />
              &nbsp Max: <input type="text" className="rangebox" defaultValue={att.max} />
            </div>
          )}
        </div>
      )
    }
    
    else {
      content = "att type not supported"
  }
  
  const handleDirtyBitClick = () => {
    
    if (!att) return

    if (att.type === "multiselect") {
      att.options.forEach((option) => {
        const baseValue = base[option.name] == null ? att.defaultValue : base[option.name]
        setPlay(prod.uid, option.name, baseValue)
      })
    } else {
      const baseValue = base[att.name] || att.defaultValue
      setPlay(prod.uid, att.name, baseValue)
    }
  }


  const multiSelectMessage = att.type === "multiselect" ? (att.maxSelect ? `(Select up to ${att.maxSelect})` : "(Select multiple)") : null
  const lightBlue = monitor_atts?.includes(att.name) ? { backgroundColor: 'rgba(66,133,250, 0.05)', position:'relative' } : null

    return (
      <div className={"attribute-box" + (error ? " has-error" : "")} style={lightBlue}>
        {
          monitor_atts?.includes(att.name) ?
            <div style={{position:'absolute', right:10,top:10, fontSize:'5pt', color:'#808080'}}>
              <span>IMPACTS MODEL LEVEL</span>
            </div>
            :
            null
        }
        <div className={"title " + (isAttLocked ? "locked" : "unlocked")} 
          onClick={() => {
            if (allowOptimize) {
              dispatch(optimActionCreators.setAttLock(prod.uid, att.name, !isAttLocked, play[att.name] || att.defaultValue))
            }
          }}
        >
          <label title={error}>
            {debug ? <span>[{att.name}]</span> : null}

            {att.label}
            {multiSelectMessage ? <span className="multi-select-message">{multiSelectMessage}</span> : null}
            {dirty && !allowOptimize ? (
              <span className="dirty-bit" onClick={handleDirtyBitClick}>
                <i className="fas fa-circle" />
              </span>
            ) : null}
          </label>
          {error ? (
            <div>
              <span className="error-bit">
                <span className="glyph">
                  <i className="fas fa-exclamation-triangle" />
                </span>
                <span className="message">{error}</span>
              </span>
            </div>
          ) : null}
        
        </div>
        <div className={allowOptimize ? "opt-level-container" : "level-container"}>
          {content}
        </div>
      </div>
    )
  
}

